import { useSchoolLayoutStore } from "@/hooks/stores/schoolLayoutStore"
import { SchoolSidebar } from "./school-dashboard/school-sidebar"

interface SchoolLayoutProps {
  children: React.ReactNode
}

/**
 * Shared layout wrapper for all school admin pages.
 * Renders the sidebar and a main content area whose left margin
 * automatically tracks the sidebar's collapsed/expanded state.
 *
 * Sidebar widths:  expanded → w-56 (224 px)  collapsed → w-16 (64 px)
 * Main margins:    expanded → ml-56           collapsed → ml-16
 */
export function SchoolLayout({ children }: SchoolLayoutProps) {
  const isCollapsed = useSchoolLayoutStore((s) => s.isCollapsed)

  return (
    <div className="flex min-h-screen bg-gray-50">
      <SchoolSidebar />
      <main
        className={`flex-1 overflow-auto transition-all duration-300 ${
          isCollapsed ? "lg:ml-16" : "lg:ml-56"
        }`}
      >
        {children}
      </main>
    </div>
  )
}
